<template>
  <tr
    :class="{ 'is-official': instance.official }"
    @click="$emit('open')">
    <td>
      <span
        v-if="instance.winner_faction"
        class="winner-star"
        :class="getTheme(instance.winner_faction)"
        v-tooltip="$t('portal_components.instance_row.won_by', {
          faction: $t(`data.faction.${instance.winner_faction}.name`),
        })">★</span>
      <svgicon
        v-else
        class="icon"
        name="disc"
        v-tooltip="$t(`instance.state.${instance.state}.toast`)"
        :class="instance.state" />
      <span
        class="star"
        v-tooltip="$t('portal_components.instance_row.registered')"
        v-show="hasRegistration">★</span>
    </td>

    <td>
      <div class="header">
        <span
          v-if="instance.official"
          class="official-badge">
          {{ $t('page.play.slow.official') }}
        </span>
        <span
          v-if="instance.game_mode_type === 'wave'"
          class="wave-badge"
          v-tooltip="$t('page.wave.short_rules')">
          {{ $t('page.wave.name') }}
        </span>
        <h2>{{ instance.name }}</h2>
        <em class="instance-id">#{{ instance.id }}</em>
        <span class="toast">
          {{ $t('portal_components.instance_row.capacity', {registeredCount: currentPlayer, maxPlayers: maxPlayer}) }}
        </span>
        <span class="toast">
          {{ $t(`map.size.${instance.game_metadata.size}.toast`) }}
        </span>
        <span
          v-if="instance.scheduled && instance.state === 'open'"
          class="toast is-scheduled">
          {{ $t('page.flash_schedule.scheduled_chip', { time: scheduledLabel }) }}
        </span>
      </div>

      <!-- Factions only. The per-faction [registered/capacity] pairs
           read as four numbers competing with the row's own capacity
           toast, and which faction has the spare seat is a lobby
           decision, not a browse-the-list one. -->
      <em class="factions">
        <span
          v-for="(f, i) in instance.factions"
          :key="`i${instance.id}-f${f.faction_ref}`">
          <template v-if="i > 0"> vs </template>
          <strong>
            <span
              class="bull"
              :class="getTheme(f.faction_ref)">
            </span>

            {{ $t(`data.faction.${f.faction_ref}.name`) }}
          </strong>
        </span>
      </em>
    </td>

    <td class="actions">
      <router-link
        v-if="instance.archive_id"
        class="default-button"
        :to="`/play/slow/archive/${instance.archive_id}`"
        @click.native.stop>
        <svgicon class="icon" name="ranking" aria-hidden="true" />
        {{ $t('page.play.archive.view_archive') }}
      </router-link>
      <button
        class="default-button"
        :class="{
          'disabled': ['instance_full', 'has_registration'].includes(action),
        }"
        :aria-disabled="['instance_full', 'has_registration'].includes(action) ? 'true' : null"
        v-if="action !== 'no_registration'"
        @click="handleClick">
        {{ $t(`instance.registration_state.${action}`) }}
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'instance-row',
  props: {
    instance: Object,
    profiles: Array,
  },
  computed: {
    faction() { return this.$store.state.portal.data.faction; },
    scheduledLabel() {
      return new Date(this.instance.scheduled.scheduled_start_at).toLocaleString(this.$i18n.locale, {
        weekday: 'short', hour: 'numeric', minute: '2-digit',
      });
    },
    maxPlayer() { return this.instance.factions.reduce((a, b) => a + b.capacity, 0); },
    currentPlayer() {
      return this.instance.factions.reduce((a, b) => a + b.registrations_count, 0);
    },
    hasRegistration() {
      return !!this.profiles
        .find((p) => p.registrations.find((p2) => p2.faction.instance.id === this.instance.id));
    },
    action() {
      if (this.instance.state === 'ended') {
        return 'no_registration';
      }

      if (this.hasRegistration) {
        return this.instance.state === 'running'
          ? 'can_play'
          : 'has_registration';
      }

      if (this.instance.registration_status === 'open') {
        return this.currentPlayer < this.maxPlayer
          ? 'can_registrate'
          : 'instance_full';
      }

      return 'no_registration';
    },
  },
  methods: {
    handleClick(e) {
      if (this.action === 'can_play') {
        e.preventDefault();

        // intercept signal
        // call play function...
      }
    },
    getTheme(key) {
      return key
        ? `theme-${this.faction.find((f) => f.key === key).theme}`
        : '';
    },
  },
};
</script>
